import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSofa: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSofa"><Path d="M3 9V4H21V9H17V12H7V9H3Z" fill="currentColor"/><Path d="M1 11V18H4V20H6V18H18V20H20V18H23V11H19V14H5V11H1Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSofa;
